import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Rx';

@Injectable()
export class AutosizeService {
  private _autosizeTrigger: Subject<any> = new Subject();

  constructor() { }

  get autosizeTrigger() {
    return this._autosizeTrigger;
  }

  triggerAdjust() {
    setTimeout((self) => {
      self._autosizeTrigger.next('');
    }, 150, this);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/autosize/autosize.service.ts